import React from 'react';
import { Button } from 'reactstrap';
import { formatDate, formatAmount, _toDash } from '../../utils';
import DataTable from '../DataTable';

const getStatusBadgeClass = (status) => {
  switch (String(status).toUpperCase()) {
    case 'PENDING':
      return 'badge badge-warning text-dark';
    case 'APPROVED':
    case 'APPLIED':
      return 'badge badge-success';
    case 'REJECTED':
      return 'badge badge-danger';
    default:
      return 'badge badge-secondary';
  }
};

const ManualTopupsTable = ({ records, loading, onSelect, limit, footer }) => {
  return (
    <DataTable card={false} loading={loading} minWidth={800} footer={footer}>
      <thead className="text-primary">
        <tr>
          <th>No.</th>
          <th>Date</th>
          <th>Reference</th>
          <th>Amount</th>
          <th>Bank</th>
          <th>Source Type</th>
          <th>Status</th>
          <th className="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.length === 0 ? (
          <tr>
            <td colSpan="8" className="text-center py-4">
              {loading
                ? 'Fetching manual topups...'
                : 'No manual topups found.'}
            </td>
          </tr>
        ) : (
          records.map((r, i) => (
            <tr
              key={r.id}
              onClick={() => onSelect(r.id)}
              style={{ cursor: 'pointer' }}
            >
              <td>{i + 1}</td>
              <td>{formatDate(r.created_at)}</td>
              <td>
                <span className="font-weight-bold text-monospace">{r.ref}</span>
              </td>
              <td>{formatAmount(r.amount)}</td>
              <td>{r.source_bank || 'N/A'}</td>
              <td>
                <span className="badge badge-info px-2 py-1">
                  {_toDash(r.source_type)}
                </span>
              </td>
              <td>
                <span className={getStatusBadgeClass(r.status)}>
                  {r.status}
                </span>
              </td>
              <td className="text-right" onClick={(e) => e.stopPropagation()}>
                <Button
                  color="info"
                  size="sm"
                  className="btn-round btn-icon btn-icon-mini"
                  onClick={() => onSelect(r.id)}
                  title="View details / Process"
                >
                  <i className="now-ui-icons gestures_tap-01" />
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </DataTable>
  );
};

export default ManualTopupsTable;
